import type { EmailTemplateChangeNote } from '../types/emailTemplate'

/** Angular: `{{ key }} : {{ value[0] }} => {{ value[1] }}` per `changes_data` entry. */
export function formatEmailTemplateNoteChangeLines(
  changesData: EmailTemplateChangeNote['changes_data'],
): string[] {
  if (!changesData || typeof changesData !== 'object') return []

  return Object.entries(changesData).map(([key, pair]) => {
    const from = Array.isArray(pair) ? (pair[0] ?? '') : ''
    const to = Array.isArray(pair) ? (pair[1] ?? '') : ''
    return `${key} : ${from} => ${to}`
  })
}
